import { Injectable } from '@angular/core';
import { BDShared } from '@brother-apps/brother-dealerapp-shared-lib';

@Injectable()
export class BDCSShareService {

    public sharedModel: BDShared;
}
